import {
  experimental_extendTheme as extendTheme,
  type CssVarsThemeOptions,
} from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { CustomerPortalTheme } from "Models/customerPortalTheme";

export const CustomerPortalDefaultThemePayload = {
  cssVarPrefix: "customer-portal",
  typography: {
    fontFamily: "Manrope",
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontWeight: 700,
          textTransform: "none",
        },
      },
    },
  },
  colorSchemes: {
    light: {
      palette: {
        grey: {
          500: colors.gray400,
        },
        primary: {
          main: colors.brandBlue600,
        },
        secondary: {
          main: colors.brandBlue50,
        },
        text: {
          primary: colors.gray600,
          secondary: colors.gray600,
        },
        background: {
          default: colors.brandBlue25,
        },
        divider: colors.gray200,
      },
    },
  },
} as CssVarsThemeOptions;

export const customerPortalDefaultTheme = extendTheme(CustomerPortalDefaultThemePayload);

export type CustomerPortalThemeType = typeof customerPortalDefaultTheme;

export const createCustomerPortalTheme = (theme: any) => {
  return extendTheme({
    ...CustomerPortalDefaultThemePayload,
    ...theme,
  });
};

export const createCustomerPortalThemeFromDatabase = (themeFromDatabase: CustomerPortalTheme) => {
  const newTheme = {
    colorSchemes: {
      light: {
        palette: {
          grey: {
            500: "#98A2B3",
          },
          primary: {
            main: themeFromDatabase.primaryColor,
          },
          secondary: {
            main: themeFromDatabase.secondaryColor,
          },
          text: {
            primary: themeFromDatabase.textPrimary,
            secondary: themeFromDatabase.textSecondary,
          },
          background: {
            default: themeFromDatabase.backgroundColor,
          },
          divider: themeFromDatabase.divider,
        },
      },
    },
  };

  return createCustomerPortalTheme(newTheme);
};
